import { render } from "./OverallBookStatistics.vue?vue&type=template&id=49f9ef99&scoped=true"
import script from "./OverallBookStatistics.vue?vue&type=script&lang=js"
export * from "./OverallBookStatistics.vue?vue&type=script&lang=js"

import "./OverallBookStatistics.vue?vue&type=style&index=0&id=49f9ef99&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f9ef99"]])

export default __exports__